var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLetterJ(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30.73h1.12C8.49 52 18.55 66.15 28.38 66.15c3.46 0 6.15-1.79 6.15-6.71V15.2c0-8.61-6.26-12.41-9.28-14.64V0H80v.56a18 18 0 00-7.37 14.64v53.07c0 6.81-5.14 11.73-12.41 11.73H0z",
    fill: "#e8ffa2"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MCIgaGVpZ2h0PSI4MCIgdmlld0JveD0iMCAwIDgwIDgwIj4KICA8cGF0aCBkPSJNMCwzMC43M0gxLjEyQzguNDksNTIsMTguNTUsNjYuMTUsMjguMzgsNjYuMTVjMy40NiwwLDYuMTUtMS43OSw2LjE1LTYuNzFWMTUuMmMwLTguNjEtNi4yNi0xMi40MS05LjI4LTE0LjY0VjBIODBWLjU2QTE4LDE4LDAsMCwwLDcyLjYzLDE1LjJWNjguMjdDNzIuNjMsNzUuMDgsNjcuNDksODAsNjAuMjIsODBIMFoiIGZpbGw9IiNlOGZmYTIiLz4KPC9zdmc+Cg==";
export { SvgLetterJ as ReactComponent };